export const translations: Record<string, string> = {
  // Navigation
  'nav.home': 'Home',
  'nav.mobileLiving': 'Mobile Living',
  'nav.offGridHomes': 'Off-Grid Homes',
  'nav.boatLiving': 'Boat Living',
  'nav.camping': 'Camping',
  'nav.about': 'About',
  'nav.search': 'Search',
  'nav.searchPlaceholder': 'Search articles...',
  
  // Hero
  'hero.title': 'Modern Nomad Living',
  'hero.subtitle': 'Discover the art of alternative living — from vans and tiny homes to boats and off-grid cabins. Personal insights, honest tips, and inspiration for your journey.',
  'hero.cta': 'Explore Categories',
  
  // Home
  'home.categories': 'Explore Categories',
  'home.latestArticles': 'Latest Articles',
  'home.readMore': 'Read More',
  'home.viewAll': 'View All',
  
  // Categories
  'category.mobileLiving': 'Mobile Living',
  'category.mobileLiving.desc': 'Life on wheels — vans, buses, and tiny homes that move with you.',
  'category.offGridHomes': 'Off-Grid Homes',
  'category.offGridHomes.desc': 'Self-sufficient living in tiny houses, dome homes, and cabins.',
  'category.boatLiving': 'Boat Living',
  'category.boatLiving.desc': 'Make the water your home — marina life and sailing adventures.',
  'category.camping': 'Camping',
  'category.camping.desc': 'Outdoor living, tent life, and the freedom of the wild.',
  
  // Article
  'article.publishedOn': 'Published on',
  'article.relatedArticles': 'Related Articles',
  'article.backToCategory': 'Back to',
  
  // Footer
  'footer.tagline': 'Exploring alternative ways of living, one adventure at a time.',
  'footer.affiliate': 'This site may contain affiliate links. We only recommend products we genuinely believe in.',
  'footer.rights': 'All rights reserved.',
  
  // About
  'about.title': 'About',
  'about.intro': 'Hi! I\'m a passionate researcher and hobbyist exploring the world of alternative living. This isn\'t expert advice — it\'s honest insights from someone who loves diving deep into these topics.',
  
  // Search
  'search.title': 'Search Results',
  'search.noResults': 'No articles found for',
  'search.resultsFor': 'results for',
  
  // Newsletter
  'newsletter.heading': 'Stay Inspired',
  'newsletter.description': 'Get weekly insights on alternative living — honest tips, new guides, and ideas for your next chapter.',
  'newsletter.placeholder': 'Your email address',
  'newsletter.cta': 'Subscribe',
  'newsletter.privacy': 'No spam. Unsubscribe anytime.',
  'newsletter.success': 'Welcome aboard!',
  'newsletter.successDesc': 'You\'ll receive our next update soon.',
  'newsletter.thankYou': 'Thank You',
  'newsletter.confirmText': 'You\'re on the list. We\'ll be in touch soon.',

  // Author
  'author.writtenBy': 'Written by',
  'author.name': 'Carl S Molner',
  'author.bio': 'Editor and researcher covering alternative living since 2024. Based in Stockholm. Writes after months of field interviews, gear testing, and reading the boring manuals so you don\'t have to.',
  'author.learnMore': 'About us',

  // CTA
  'cta.audible.title': 'Learn More on the Go',
  'cta.audible.text': 'Love learning about alternative living? Explore audiobooks on sustainable living, minimalism, and adventure with Audible.',
  'cta.audible.button': 'Try Audible Free',
  
  // Book recommendation
  'book.by': 'by',
  'book.offer': '30 days free · Any audiobook · Cancel anytime',
  'book.cta': 'Listen free for 30 days',
  
  // Share
  'share.title': 'Share this article',
  'share.via': 'Share via',
  'share.copyLink': 'Copy link',
  'share.copied': 'Link copied!',
  
  // Glossary
  'nav.glossary': 'Glossary',
  'nav.tools': 'Tools',
  'glossary.title': 'Glossary',
  'glossary.intro': 'A comprehensive guide to terms and concepts in alternative living — from van life and off-grid homes to boat living and beyond.',
  'glossary.metaDescription': 'Explore our glossary of alternative living terms. Learn about van life, tiny homes, off-grid living, boat life, and more with warm, detailed explanations.',
  'glossary.filterAll': 'All Terms',
  'glossary.general': 'General',
  'glossary.relatedArticles': 'Related Articles',
  
  // Contact
  'nav.contact': 'Contact',
  'contact.title': 'Contact Us',
  'contact.intro': 'Have a question, suggestion, or just want to say hello? We\'d love to hear from you.',
  'contact.emailTitle': 'Email Us',
  'contact.responseTime': 'Response Time',
  'contact.responseTimeText': 'We typically respond within 2-3 business days.',
  'contact.helpTitle': 'What We Can Help With',
  'contact.help1': 'Questions about our articles and guides',
  'contact.help2': 'Suggestions for new topics',
  'contact.help3': 'Partnership and collaboration inquiries',
  'contact.help4': 'General feedback and ideas',
  'contact.note': 'Please note that we are hobbyist researchers, not professional advisors. For specific technical, legal, or financial questions, we recommend consulting qualified professionals.',
  
  // Privacy Policy
  'nav.privacyPolicy': 'Privacy Policy',
  'privacy.title': 'Privacy Policy',
  'privacy.lastUpdated': 'Last Updated',
  
  // Terms
  'nav.terms': 'Terms',
  'terms.title': 'Terms of Use & Disclaimer',
  'terms.lastUpdated': 'Last Updated',
};

export const getTranslation = (key: string): string => {
  return translations[key] || key;
};
